import { useTranslation } from "react-i18next"

import BasicButton from "@/components/button/BasicButton"
import TextField from "@/components/form/textField/TextField"
import type { UpsertFilterPresetPayload } from "@/types/filterPreset"
import ReportFilterFields from "./ReportFilterFields"

import "./filterPreset.scss"

interface FilterPresetEditorProps {
  form: UpsertFilterPresetPayload
  updateForm: (updates: Partial<UpsertFilterPresetPayload>) => void
  onSave: () => void
  onDelete: () => void
  isSaving: boolean
  isDeleting: boolean
  isValid: boolean
  hasChanges: boolean
  isExisting: boolean
}

export default function FilterPresetEditor({
  form,
  updateForm,
  onSave,
  onDelete,
  isSaving,
  isDeleting,
  isValid,
  hasChanges,
}: FilterPresetEditorProps) {
  const { t } = useTranslation()

  return (
    <div className="FilterPresetEditorCont">
      <ReportFilterFields
        form={form}
        updateForm={updateForm}
        nameSlot={
          <div className="FilterPresetEditor__field FilterPresetEditor__field--full">
            <label className="FilterPresetEditor__label">{t("presetName", "Preset Name")}</label>
            <TextField
              value={form.name}
              onChange={(e) => updateForm({ name: e.target.value })}
              placeholder={
                t("filterPresetNamePlaceholder", "e.g., Weekly Training Report") as string
              }
              size="small"
              inputProps={{ maxLength: 50 }}
            />
          </div>
        }
      />

      {/* Actions */}
      <div className="FilterPresetEditor__actions">
        <BasicButton type="danger-outlined" size="sm" onClick={onDelete} disabled={isDeleting}>
          {t("button.delete", "Delete")}
        </BasicButton>
        <BasicButton
          type="primary-contained"
          size="sm"
          onClick={onSave}
          disabled={!isValid || !hasChanges || isSaving}
          isLoading={isSaving}>
          {t("button.save")}
        </BasicButton>
      </div>
    </div>
  )
}
